"use strict";
/* istanbul ignore file - it's tested in Chromatic */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
var lodash_flow_1 = __importDefault(require("lodash.flow"));
var react_1 = __importStar(require("react"));
var core_1 = require("./core");
var styled_1 = require("./core/styled");
exports.Box = Object.assign((0, react_1.forwardRef)(function Box(props, ref) {
    return react_1.default.createElement(StyledBox, __assign({ ref: ref }, processProps(props)));
}), {
    Button: (0, react_1.forwardRef)(function BoxButton(_a, ref) {
        var disabled = _a.disabled, onClick = _a.onClick, props = __rest(_a, ["disabled", "onClick"]);
        return (react_1.default.createElement(StyledBox, __assign({ ref: ref, "aria-disabled": disabled, clickable: !disabled, disabled: disabled, onClick: disabled ? undefined : onClick, role: 'button' }, processProps(props))));
    }),
});
var StyledBox = (0, core_1.styled)('div', {
    borderStyle: 'solid',
    borderWidth: 0,
    /**
     * Line height should come from the Text component!
     * Otherwise we'll get surprise misalignment for elements smaller than the default line height.
     * For example:
     *
     *     <Box>
     *       <Text size="$10px" />
     *     </Box>
     * results in the small text being placed at the bottom of a 22px line which comes from default browser styles,
     * with over 8px of extra space at the top.
     */
    lineHeight: 0,
    outlineStyle: 'solid',
    outlineWidth: 0,
    position: 'relative',
}, {
    background: __assign(__assign(__assign({}, (0, core_1.mapTokens)('backgrounds', function (value) { return ({ background: value }); })), (0, core_1.mapTokens)('colors', function (value) { return ({ backgroundColor: value }); })), (0, styled_1.mapCustom)('customColor', function (value) { return ({ backgroundColor: value }); })),
    borderBottomColor: (0, core_1.mapTokens)('colors', function (value) { return ({ borderBottomColor: value }); }),
    borderBottomLeftRadius: (0, core_1.mapTokens)('radii', function (value) { return ({ borderBottomLeftRadius: value }); }),
    borderBottomRightRadius: (0, core_1.mapTokens)('radii', function (value) { return ({ borderBottomRightRadius: value }); }),
    borderBottomWidth: (0, core_1.mapTokens)('borderWidths', function (value) { return ({ borderBottomWidth: value }); }),
    borderLeftColor: (0, core_1.mapTokens)('colors', function (value) { return ({ borderLeftColor: value }); }),
    borderLeftWidth: (0, core_1.mapTokens)('borderWidths', function (value) { return ({ borderLeftWidth: value }); }),
    borderRightColor: (0, core_1.mapTokens)('colors', function (value) { return ({ borderRightColor: value }); }),
    borderRightWidth: (0, core_1.mapTokens)('borderWidths', function (value) { return ({ borderRightWidth: value }); }),
    borderTopColor: (0, core_1.mapTokens)('colors', function (value) { return ({ borderTopColor: value }); }),
    borderTopLeftRadius: (0, core_1.mapTokens)('radii', function (value) { return ({ borderTopLeftRadius: value }); }),
    borderTopRightRadius: (0, core_1.mapTokens)('radii', function (value) { return ({ borderTopRightRadius: value }); }),
    borderTopWidth: (0, core_1.mapTokens)('borderWidths', function (value) { return ({ borderTopWidth: value }); }),
    center: {
        true: { alignItems: 'center', display: 'flex', justifyContent: 'center' },
        horz: { display: 'flex', justifyContent: 'center' },
        vert: { alignItems: 'center', display: 'flex' },
    },
    clickable: { true: { cursor: 'pointer', userSelect: 'none' } },
    disabled: { true: { cursor: 'not-allowed', opacity: 0.5, userSelect: 'none' } },
    full: { true: { height: '$full', width: '$full' } },
    height: __assign(__assign(__assign({}, (0, core_1.mapTokens)('sizes', function (value) { return ({ height: value }); })), (0, core_1.mapTokens)('space', function (value) { return ({ height: value }); })), (0, styled_1.mapCustom)('customSize', function (value) { return ({ height: value }); })),
    maxHeight: __assign(__assign(__assign({}, (0, core_1.mapTokens)('sizes', function (value) { return ({ maxHeight: value, overflowY: 'auto' }); })), (0, core_1.mapTokens)('space', function (value) { return ({ maxHeight: value, overflowY: 'auto' }); })), (0, styled_1.mapCustom)('customSize', function (value) { return ({ maxHeight: value, overflowY: 'auto' }); })),
    maxWidth: __assign(__assign(__assign({}, (0, core_1.mapTokens)('sizes', function (value) { return ({ maxWidth: value, overflowX: 'auto' }); })), (0, core_1.mapTokens)('space', function (value) { return ({ maxWidth: value, overflowX: 'auto' }); })), (0, styled_1.mapCustom)('customSize', function (value) { return ({ maxWidth: value, overflowX: 'auto' }); })),
    minHeight: __assign(__assign(__assign({}, (0, core_1.mapTokens)('sizes', function (value) { return ({ minHeight: value }); })), (0, core_1.mapTokens)('space', function (value) { return ({ minHeight: value }); })), (0, styled_1.mapCustom)('customSize', function (value) { return ({ minHeight: value }); })),
    minWidth: __assign(__assign(__assign({}, (0, core_1.mapTokens)('sizes', function (value) { return ({ minWidth: value }); })), (0, core_1.mapTokens)('space', function (value) { return ({ minWidth: value }); })), (0, styled_1.mapCustom)('customSize', function (value) { return ({ minWidth: value }); })),
    outlineColor: (0, core_1.mapTokens)('colors', function (value) { return ({ outlineColor: value }); }),
    outlineWidth: (0, core_1.mapTokens)('borderWidths', function (value) { return ({ outlineWidth: value }); }),
    shadow: (0, core_1.mapTokens)('shadows', function (value) { return ({ boxShadow: value }); }),
    spaceBottom: (0, core_1.mapTokens)('space', function (value) { return ({ paddingBottom: value }); }),
    spaceLeft: (0, core_1.mapTokens)('space', function (value) { return ({ paddingLeft: value }); }),
    spaceRight: (0, core_1.mapTokens)('space', function (value) { return ({ paddingRight: value }); }),
    spaceTop: (0, core_1.mapTokens)('space', function (value) { return ({ paddingTop: value }); }),
    width: __assign(__assign(__assign({}, (0, core_1.mapTokens)('sizes', function (value) { return ({ width: value }); })), (0, core_1.mapTokens)('space', function (value) { return ({ width: value }); })), (0, styled_1.mapCustom)('customSize', function (value) { return ({ width: value }); })),
});
var processBorder = (0, lodash_flow_1.default)(getBorderMixin('border', function (border) { return ({ borderHorz: border, borderVert: border }); }), getBorderMixin('borderHorz', function (border) { return ({ borderLeft: border, borderRight: border }); }), getBorderMixin('borderVert', function (border) { return ({ borderTop: border, borderBottom: border }); }), getBorderMixin('borderTop', mapMultiBorderToProps('borderTopColor', 'borderTopWidth')), getBorderMixin('borderRight', mapMultiBorderToProps('borderRightColor', 'borderRightWidth')), getBorderMixin('borderBottom', mapMultiBorderToProps('borderBottomColor', 'borderBottomWidth')), getBorderMixin('borderLeft', mapMultiBorderToProps('borderLeftColor', 'borderLeftWidth')), getBorderMixin('outline', mapMultiBorderToProps('outlineColor', 'outlineWidth')));
var processBorderRadius = (0, lodash_flow_1.default)(getBorderRadiusMixin('borderRadius', function (radius) { return ({ borderLeftRadius: radius, borderRightRadius: radius }); }), getBorderRadiusMixin('borderLeftRadius', function (radius) { return ({
    borderTopLeftRadius: radius,
    borderBottomLeftRadius: radius,
}); }), getBorderRadiusMixin('borderRightRadius', function (radius) { return ({
    borderTopRightRadius: radius,
    borderBottomRightRadius: radius,
}); }), getBorderRadiusMixin('borderTopRadius', function (radius) { return ({ borderTopLeftRadius: radius, borderTopRightRadius: radius }); }), getBorderRadiusMixin('borderBottomRadius', function (radius) { return ({
    borderBottomLeftRadius: radius,
    borderBottomRightRadius: radius,
}); }));
var processSpace = (0, lodash_flow_1.default)(getSpaceMixin('space', function (space) { return ({ spaceHorz: space, spaceVert: space }); }), getSpaceMixin('spaceHorz', function (space) { return ({ spaceLeft: space, spaceRight: space }); }), getSpaceMixin('spaceVert', function (space) { return ({ spaceTop: space, spaceBottom: space }); }));
var processProps = (0, lodash_flow_1.default)(processBorder, processBorderRadius, processSpace);
function getBorderMixin(borderName, map) {
    return function (_a) {
        var _b = borderName, border = _a[_b], props = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return (border ? __assign(__assign({}, map(border)), props) : props);
    };
}
function mapMultiBorderToProps(colorPropName, widthPropName) {
    return function (border) {
        var _a, _b;
        return Array.isArray(border)
            ? (_a = {}, _a[colorPropName] = border[0], _a[widthPropName] = border[1], _a) : (_b = {}, _b[colorPropName] = border, _b[widthPropName] = '$1px', _b);
    };
}
function getBorderRadiusMixin(borderRadiusName, map) {
    return function (_a) {
        var _b = borderRadiusName, radiusValue = _a[_b], props = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return (radiusValue ? __assign(__assign({}, map(radiusValue)), props) : props);
    };
}
function getSpaceMixin(spaceName, map) {
    return function (_a) {
        var _b = spaceName, spaceValue = _a[_b], props = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return (spaceValue ? __assign(__assign({}, map(spaceValue)), props) : props);
    };
}
